import axios from '../http'

function add(data) {
    return axios.post('/basedata/roundDoc/add', data);
}

function del(data) {
    return axios.post('/basedata/roundDoc/del', data);
}

function update(data) {
    return axios.post('/basedata/roundDoc/update', data);
}

function query(data) {
    return axios.post('/basedata/roundDoc/query', data);
}


function get(id) {
    return axios.get('/basedata/roundDoc/get?id=' + id);
}

function getOptions(status) {
    if(status == undefined){
        status="";
    }
    return axios.post('/basedata/roundDoc/getOptions?status='+status);
}

function importExcel(file){
    let formData = new FormData();
    formData.append("file", file);
    return axios.post("/basedata/roundDoc/importExcel", formData, {headers: {"Content-type": "multipart/form-data"}});
    
}

function exportExcel(data){
    const url =  "/basedata/roundDoc/exportExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Round Doc"+ (new Date()).valueOf() +".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

export default {
    add,
    del,
    update,
    query,
    get,
    getOptions,
    importExcel,
    exportExcel
}